//@flow
import React, {useState} from 'react';
import {Typography, makeStyles} from '@material-ui/core';
import type {Theme} from '@material-ui/core';

import type {MessageMultimedia} from '../../../../../../../../entities';
import VideoRenderer from '../../../../../../../../elements/VideoRenderer';
import {colors} from '../../../../../../../../assets/styles/colors';
import {fetchWhatsappApiMedia} from '../../../../../utils/message';
import {useCurrentConversation} from '../../../../../utils/conversation';
import DownloadIcon from '../../../../../../../../elements/icons/DownloadIcon';
import InlineLoader from '../../../../../../../../elements/LoadingSpinner/InlineLoader';

const useStyles = (props: any) =>
  makeStyles((theme: Theme) => ({
    pictureMessageWrap: {
      gap: '.5rem',
      background: props.self ? '#d5bfff' : '#F4F4F6',
      borderRadius: '.75rem',
      padding: '.5rem',
      width: '90%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      maxWidth: '320px',
      position: 'relative',
      minWidth: '250px',

      '&[data-single="true"]': {
        gridTemplateColumns: '1fr',
        aspectRatio: '1/1',
      },

      '&:hover .see-more-picture-button': {
        opacity: 1,
      },
      '&:focus-within .see-more-picture-button': {
        opacity: 1,
      },
    },
    pictureMessage: {
      width: '100%',
      borderRadius: '.75rem',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '0',
      border: 'none',
      background: 'none',
      cursor: 'pointer',
      overflow: 'hidden',
    },

    video: {
      width: '100%',
      height: 'auto',
      // objectFit: 'cover',
      objectFit: 'contain',
    },
    errorOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: colors.grey900,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '1rem',
      borderRadius: '.75rem',
      zIndex: 1,
    },
    errorText: {
      fontSize: '.8rem',
      fontWeight: 500,
      color: '#fff',
      textAlign: 'center',
    },
    downloadIcon: {
      width: '100px',
      height: '100px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '2rem',
      color: colors.primary,
      borderRadius: '.75rem',
    },
    loader: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      background: 'rgba(255, 255, 255, 0.8)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1,
    },
  }));

type Props = {
  video: MessageMultimedia,
  self: boolean,
};

export default function VideoMessage({video, self}: Props) {
  const classes = useStyles({self})();

  const [videoError, setVideoError] = useState(false);

  const {currentConversation} = useCurrentConversation();

  const [src, setSrc] = useState(video.src);
  const [loading, setLoading] = useState(false);

  const handleClick = () => {
    if (!currentConversation) return;

    if (video.mediaId) {
      setLoading(true);
      fetchWhatsappApiMedia(currentConversation.deviceId, video?.mediaId || '')
        .then(source => {
          setSrc(source);
        })
        .catch(() => {
          console.log('Error fetching video');
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };
  if (!src) {
    return (
      <div className={classes.pictureMessageWrap} onClick={handleClick}>
        <div className={classes.pictureMessage}>
          <span className={classes.downloadIcon}>
            <DownloadIcon />
          </span>

          {loading && (
            <div className={classes.loader}>
              <InlineLoader loading size={20} />
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className={classes.pictureMessageWrap}>
      {videoError && (
        <div className={classes.errorOverlay}>
          <Typography className={classes.errorText}>
            El video no esta disponible. <br />
            <br />
            Ingresa a la aplicación {'(Instagram o Facebook)'} para verlo.
          </Typography>
        </div>
      )}

      <div className={classes.pictureMessage}>
        <VideoRenderer
          src={src}
          controls
          className={classes.video}
          onError={() => setVideoError(true)}
        />
      </div>
    </div>
  );
}
